import { gql } from '@apollo/client';
import { INVOICE_DETAIL_FIELDS } from '../../fragments';
import { InvoiceType } from '../../../types';
import { ApolloClientFunctionProps } from '../../utils';
import { GetInvoiceByDepartmentIdProps, GetInvoiceByInvoiceIdProps } from './invoice.types';

export const GET_INVOICES = gql`
  ${INVOICE_DETAIL_FIELDS}
  query GetInvoiceList {
    invoices {
      ...InvoiceDetailFields
    }
  }
`;

export function getInvoices({ client }: ApolloClientFunctionProps) {
  return client?.watchQuery<{ invoices: InvoiceType[] }>({
    query: GET_INVOICES,
  });
}

export const GET_INVOICE_BY_INVOICE_ID = gql`
  ${INVOICE_DETAIL_FIELDS}
  query GetInvoiceByInvoiceId($invoiceId: ID!) {
    invoiceByInvoiceId(invoiceId: $invoiceId) {
      ...InvoiceDetailFields
    }
  }
`;

export function getInvoiceByInvoiceId({ client, invoiceId }: GetInvoiceByInvoiceIdProps) {
  return client?.watchQuery<{ invoiceByInvoiceId: InvoiceType }>({
    query: GET_INVOICE_BY_INVOICE_ID,
    variables: {
      invoiceId,
    },
  });
}

export const GET_INVOICES_BY_DEPARTMENT_ID = gql`
  ${INVOICE_DETAIL_FIELDS}
  query GetInvoicesByDepartmentId($departmentId: ID!) {
    invoicesByDepartmentId(departmentId: $departmentId) {
      ...InvoiceDetailFields
    }
  }
`;

export function getInvoiceByDepartmentId({ client, departmentId }: GetInvoiceByDepartmentIdProps) {
  return client?.watchQuery<{ invoicesByDepartmentId: InvoiceType[] }>({
    query: GET_INVOICES_BY_DEPARTMENT_ID,
    variables: {
      departmentId,
    },
  });
}
